import React from "react";
import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import Navbar from "./Navbar";
import Header from "./Header";
import HowItWorks from "./HowItWorks";
import About from "./About";
import Services from "./Services";
import Contact from "./ContactUs";
import Footer from "./Footer";
import Error404 from "./Error404";
export default function AllComponent() {
  return (
    <>
   <Header/>
   <HowItWorks/>
   <About/>
   <Services/>
   <Contact/>
   <Footer/>
   </>
  );
}
